// Formatter monetario para PDFs. Mantiene paridad con
// CLIENTE_PROLIFT/src/pdf/PresupuestoV2/BudgetBody/BudgetRecord.jsx
// (pre-refactor low-code). CLP sin decimales, UF/USD con dos.
const numberFormatter = new Intl.NumberFormat('es-CL', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const decimalFormatter = new Intl.NumberFormat('es-CL', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatMoney(value, moneda = 'CLP') {
  const m = (moneda || 'CLP').toUpperCase();
  const v = Number(value || 0);
  if (m === 'UF') return `UF ${decimalFormatter.format(v)}`;
  if (m === 'USD') return `US$ ${decimalFormatter.format(v)}`;
  return `$${numberFormatter.format(v)}`;
}
